<template>
  <div>
    <v-menu
      bottom
      left
      :loading="isLoading"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          icon
          v-bind="attrs"
          v-on="on"
          :data-cy="`menu-${index}`"
        >
          <v-icon color="black">{{ mdiDotsVertical }}</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, i) in menuItems(item)"
          :key="i"
          :to="item.to"
          :data-cy="`menu-item-${i}`"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon  }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="item.state !== 'Split'"
          data-cy="menu-item-complete"
          @click="complete(item)"
        >
          <v-list-item-icon>
            <v-icon>{{ mdiCheckDecagram }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Complete</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <ModalStockItemActivities />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  mdiCallSplit,
  mdiCheckAll,
  mdiCheckDecagram,
  mdiDotsVertical,
  mdiPencil,
} from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import factoryChecks from '../mixins/factoryChecks';
import ModalStockItemActivities from './ModalStockItemActivities.vue';

export default {
  name: 'FactoryItemActions',
  components: { ModalStockItemActivities },
  mixins: [factoryChecks, loading],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      /**
      * icons
      */
      mdiCallSplit,
      mdiCheckAll,
      mdiCheckDecagram,
      mdiDotsVertical,
      mdiPencil,
      /**
      * variables
      */
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('stockItems', ['COMPLETE_stockItem']),
    async complete(item) {
      const result = await this.$confirm('Are you sure item is completed?');
      if (result) {
        this.isLoading = true;
        try {
          await this.COMPLETE_stockItem({
            id: item.id,
            parentStockItemId: item.parentStockItemId,
          });
        } catch (error) {
          this.$log.error(error);
        } finally {
          this.isLoading = false;
        }
        this.$emit('refresh');
      }
    },
    menuItems(item) {
      const menuItems = this.getStockTypeMenuItems(item);
      /** Menu items
       */
      let result = [];
      if (item.state !== 'Processing-Split') {
        result = [{
          title: 'Edit',
          to: {
            name: 'processing-EditFactoryItem',
            query: { id: item.id },
            icon: mdiPencil,
          },
        }];
      }
      return [...menuItems, ...result];
    },
  },
};
</script>
